module.exports = __webpack_public_path__ + "static/media/mdwa.34af6454.eot";